<template>
  <v-dialog width="600" v-model="show">
    <v-card>
      <v-card-title>
        {{ $t('maintenance') }}
      </v-card-title>
      <v-card-text class="text-subtitle-1" v-html="message"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click="close">{{ $t('close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/** Default maintenance message in case translations aren't/can't be loaded. */
const defaultMsg = 'Currently undergoing maintenance. Please check back later'

export default {
  name: 'MaintenanceModal',
  data () {
    return {
      show: false
    }
  },
  methods: {
    close () {
      this.show = false
    }
  },
  computed: {
    message () {
      return this.$te('maintenance_message') ? this.$t('maintenance_message') : defaultMsg
    }
  },
  mounted () {
    // Watch the maintenance modal application state for changes
    this.$store.watch(
      (state) => this.$store.state.globalMessagingModule.maintenanceMode,
      (newValue, oldValue) => {
        this.show = newValue === true
      }
    )
  }
}
</script>
